export default "__VITE_ASSET__676e7ef2__"